
export enum Status {
  Current = 'current',
  Hidden = 'hidden',
  Deleted = 'deleted',
  Archived = 'archived'
}

export const isStatus = (value: string): value is Status => {
  return Object.values(Status).includes(value as Status)
}

export const status2TranslationMap: Map<string, string> = new Map([
  [Status.Current, 'Текущие комплекты'],
  // [Status.Hidden, 'Скрытые комплекты'], // заменено на Архив
  // [Status.Deleted, 'Удаленные комплекты'], // заменено на Архив
  [Status.Archived, 'Архив'],
])

export const status2ColorMap: Map<string, string> = new Map([
  [Status.Current, '#4caf50'],
  [Status.Hidden, '#ef6c00'],
  [Status.Deleted, '#e91e63'],
  [Status.Archived, '#ef6c00'],
])
